import { render } from "./CompletedDialog.vue?vue&type=template&id=2bc7de24"
import script from "./CompletedDialog.vue?vue&type=script&lang=js"
export * from "./CompletedDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__